const CARS_MAKERS = ["Citroen", "Mercedes-Benz", "BMW", "Dodge"];
export default CARS_MAKERS;
